import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import leoraIcon from '../../assets/leoraIcon_black.png';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';

export default function LoginPage() {
  const { login, isAuthenticated } = useAuth();
  const { showToast } = useToast();
  const location = useLocation();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  if (isAuthenticated) {
    return <Navigate to={location.state?.from?.pathname || '/leoradmin'} replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(username, password);
      showToast('Sesión iniciada correctamente');
    } catch (err) {
      showToast(err.message || 'Error al iniciar sesión', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <form className="admin-card admin-login-card" onSubmit={handleSubmit}>
        <img src={leoraIcon} alt="Leora" className="admin-login-card__logo" />
        <div className="admin-login-card__fields">
        <div className="admin-field" style={{ marginTop: 20 }}>
          <label className="admin-label" htmlFor="username">Usuario</label>
          <input
            id="username"
            className="admin-input"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            required
          />
        </div>
        <div className="admin-field" style={{ marginTop: 16 }}>
          <label className="admin-label" htmlFor="password">Contraseña</label>
          <div className="admin-password-field">
            <input
              id="password"
              type={showPassword ? 'text' : 'password'}
              className="admin-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
            <button
              type="button"
              className="admin-password-toggle"
              onClick={() => setShowPassword((v) => !v)}
              aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
              aria-pressed={showPassword}
            >
              {showPassword ? (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
                  <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94" />
                  <path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19" />
                  <line x1="1" y1="1" x2="23" y2="23" />
                </svg>
              ) : (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              )}
            </button>
          </div>
        </div>
        <button
          type="submit"
          className="admin-btn admin-btn--primary"
          style={{ width: '100%', marginTop: 20 }}
          disabled={loading}
        >
          {loading ? <span className="admin-spinner" /> : 'Iniciar sesión'}
        </button>
        </div>
      </form>
    </div>
  );
}
